import { CustomSpin } from "@UI/CustomSpin"
import ReceivedPaymentDetailBody from "./components/ReceivedPaymentDetailBody/ReceivedPaymentDetailBody"
import ReceivedPaymentDetailHeader from "./components/ReceivedPaymentDetailHeader/ReceivedPaymentDetailHeader"
import { ReceivedPaymentDetailContextProvider } from "./context/ReceivedPaymentDetailContext"
import { COLLECTION_ADMINISTRATION_CODES, COLLECTION_ADMINISTRATION_CODES_NAMES } from "@constants/modules/collectionAdministration/collectionAdministrationCodes"
import { useFeatureRole } from "@thooks/useFeatureRole"


const ReceivedPaymentDetailPage = () => {

    const { loadingFeatures } = useFeatureRole({
        feature_codes: COLLECTION_ADMINISTRATION_CODES,
        validate_code: COLLECTION_ADMINISTRATION_CODES_NAMES.COLLECTION_ADMINISTRATION_CHECK_DETAIL_PAYMENT,
        returnUrl: '/administration-collection',
    })

    if (loadingFeatures) return <CustomSpin tip="Cargando módulo" />
    return (
        <section className="section-wrapper">
            <ReceivedPaymentDetailContextProvider>
                <ReceivedPaymentDetailHeader />
                <ReceivedPaymentDetailBody />
            </ReceivedPaymentDetailContextProvider>
        </section>
    )
}

export default ReceivedPaymentDetailPage
